import { useDrawer } from '@app/src/components/Drawer/DrawerContext'
import DrawerViewReferralContact from '@app/src/components/Drawer/Views/DrawerViewReferralContact'
import { AvatarSize } from '@app/src/components/Ui/Avatar'
import TruncatingText from '@app/src/components/Ui/TruncatingText'
import PersonAvatar from '@app/src/pages/ResourceCollection/Collections/CellComponents/PersonAvatar'
import type { Provider } from '@app/src/types/organizations'
import { PersonOffOutlined } from '@mui/icons-material'
import { ButtonBase, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import ParentCellOrFragment from './ParentCellOrFragment'

type ReferralContactCellProps = {
  provider: Provider
  drawer?: boolean
  disableCell?: boolean
}

const ReferralContactCell: React.FC<ReferralContactCellProps> = ({ provider, drawer, disableCell }) => {
  const { openDrawer } = useDrawer()
  const { formatMessage } = useIntl()
  const contactName = provider?.referralContact?.name || ''

  return (
    <ParentCellOrFragment disableCell={disableCell}>
      {contactName ? (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          component={drawer ? ButtonBase : 'span'}
          onClick={drawer ? () => openDrawer(<DrawerViewReferralContact provider={provider} />) : undefined}
          width="100%"
          sx={{ minWidth: 0 }}
        >
          <PersonAvatar name={contactName} size={AvatarSize.Small} disabled />
          <TruncatingText
            text={contactName}
            variant="body1"
            align="left"
            sx={{ '&:hover': { textDecoration: drawer ? 'underline' : 'none' }, flexGrow: 1, flexBasis: 0 }}
          />
        </Stack>
      ) : (
        <Stack direction="row" alignItems="center" spacing={1} width="100%">
          <PersonOffOutlined color="disabled" />
          <Typography color="textSecondary" variant="body1" align="left" flexGrow={1} component="span">
            {formatMessage({ id: 'resourceExplorer.provider.notAdded' })}
          </Typography>
        </Stack>
      )}
    </ParentCellOrFragment>
  )
}

export default ReferralContactCell
